import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-left" }, "Purchase Confirmation", -1)
const _hoisted_3 = { class: "tw-mb-4 tw-text-left" }
const _hoisted_4 = { class: "tw-mb-8" }
const _hoisted_5 = {
  key: 0,
  class: "tw-font-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SchoolActivationPeriod = _resolveComponent("SchoolActivationPeriod")!
  const _component_PurchaseResume = _resolveComponent("PurchaseResume")!

  return (_ctx.purchaseData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_SchoolActivationPeriod, {
            "spelling-period": _ctx.spellingPeriod,
            "maths-period": _ctx.mathsPeriod
          }, null, 8, ["spelling-period", "maths-period"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_PurchaseResume, {
            mode: _ctx.mode,
            "school-reference": _ctx.schoolReference,
            "purchase-data": _ctx.purchaseData
          }, null, 8, ["mode", "school-reference", "purchase-data"]),
          (_ctx.activateTrial && _ctx.purchaseData.availableTrial)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Activate " + _toDisplayString(_ctx.purchaseData.availableTrial.type) + " " + _toDisplayString(_ctx.purchaseData.availableTrial.length) + " days trial ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('modify'))),
            class: "sf-btn-primary"
          }, "Modify"),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.requestInvoice && _ctx.requestInvoice(...args)), ["prevent"])),
            class: "sf-btn-primary"
          }, " Request Invoice "),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('paywithcard')), ["prevent"])),
            class: "sf-btn-primary"
          }, " Pay With Credit Card ")
        ])
      ]))
    : _createCommentVNode("", true)
}